<template>
  <section class="evento-lux">

    <!-- ===== TARJETA: CELEBRACIÓN ===== -->
    <article ref="card2" class="card" aria-label="Recepción">
      
      <!-- EFECTO POLVO DE HADAS / DESTELLOS DORADOS (OPTIMIZADO LOW-END) -->
      <div class="sparkles-container" aria-hidden="true">
        <span class="sparkle sparkle-1 render-gpu"></span>
        <span class="sparkle sparkle-2 render-gpu"></span>
        <span class="sparkle sparkle-3 render-gpu"></span>
        <span class="sparkle sparkle-4 render-gpu"></span>
        <span class="sparkle sparkle-5 render-gpu"></span>
        <span class="sparkle sparkle-6 render-gpu"></span>
      </div>

      <!-- ADORNO ESQUINA SUPERIOR IZQUIERDA -->
      <img class="adorno-top-left render-gpu" src="@/assets/esq1.png" alt="Adorno" />

      <!-- ADORNO ESQUINA INFERIOR DERECHA (FLIPPED X Y Y) -->
      <img class="adorno-bottom-right render-gpu" src="@/assets/esq1.png" alt="Adorno" />

      <img class="icono render-gpu" src="@/assets/coroa.png" alt="Corona" />
      <h3 class="titulo-script">Recepción</h3>
      <p class="hora">4:00 PM</p>
      <p class="lugar">Boulder Ridge Golf Club<br><br>Salón: Main Dining Room
</p>
      
      <!-- FOTO CIRCULAR CON MARCO ELEGANTE -->
      <div class="foto-wrapper render-gpu">
        <img class="foto-circular" src="@/assets/Gemini_Generated_Image_3d80s83d80s83d80.jpeg" alt="Salon Reina Madre" />
      </div>

      <p class="direccion">
       1000 Old Quarry Rd <br>San Jose, California.
      </p>

      <a
        ref="btn2"
        class="btn-rosa render-gpu"
        href="https://maps.app.goo.gl/5VEJWqA4unCP954S6"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>

  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const card2 = ref(null)
    const btn2 = ref(null)

    let ctx = null

    const animCard = (cardEl, btnEl) => {
      if (!cardEl || !btnEl) return

      const $ = gsap.utils.selector(cardEl)
      const adornoTL = $('.adorno-top-left')
      const adornoBR = $('.adorno-bottom-right')
      const icono    = $('.icono')
      const titulo   = $('.titulo-script')
      const hora     = $('.hora')
      const lugar    = $('.lugar')
      const foto     = $('.foto-wrapper')
      const dir      = $('.direccion')
      const sparkles = $('.sparkle')

      // Timeline principal
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 92%',
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power2.out', force3D: true }
      })

      tl.from(cardEl, { opacity: 0, y: 45, duration: 0.7, delay: 0.15 })
        .from(adornoTL, { opacity: 0, scale: 0.5, x: -30, y: -30, duration: 0.6 }, '-=0.5')
        .from(adornoBR, { opacity: 0, scale: 0.5, x: 30, y: 30, duration: 0.6 }, '-=0.6')
        .from(icono,    { opacity: 0, scale: 0.7, duration: 0.4 }, '-=0.4')
        .from(titulo,   { opacity: 0, y: 25, duration: 0.4 }, '-=0.25')
        .from(hora,     { opacity: 0, y: 20, duration: 0.3 }, '-=0.2')
        .from(lugar,    { opacity: 0, y: 20, duration: 0.3 }, '-=0.2')
        .from(foto,     { opacity: 0, scale: 0.6, rotation: -8, duration: 0.55, ease: 'back.out(1.4)' }, '-=0.15')
        .from(dir,      { opacity: 0, y: 20, duration: 0.3 }, '-=0.2')
        .from(btnEl,    { opacity: 0, scale: 0.85, duration: 0.4 }, '-=0.15')

      // Animación súper liviana para el Polvo de Hadas (Optimizado para GPU)
      gsap.to(sparkles, {
        y: -15,
        scale: 1.25,
        opacity: 0.9,
        duration: 2.2,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        stagger: {
          amount: 1.2,
          from: 'random'
        }
      })

      // Destello del botón al revelarse
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 0.9, delay: 0.3, ease: 'power2.out' }
          )
        }
      })
    }

    onMounted(() => {
      ctx = gsap.context(() => {
        gsap.config({ force3D: true })
        animCard(card2.value, btn2.value)

        // Forzar recalculado de posición tras montar
        ScrollTrigger.refresh()
      })
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return { card2, btn2 }
  }
}
</script>

<style scoped>
/* ==================== BASE ELEGANTE ==================== */
.evento-lux {
  min-height: 100%;
  padding: 20px 18px 40px;
  background: radial-gradient(circle, #6d0a14 0%, #3e0409 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

/* ==================== TARJETA ==================== */
.card {
  position: relative;
  width: min(440px, 92vw);
  padding: 26px 20px 28px;
  background: radial-gradient(circle, #6d0a14 0%, #3e0409 100%);
  text-align: center;
  box-sizing: border-box;
  border: none;
  overflow: hidden;
}

/* ==================== POLVO DE HADAS DORADO OPTIMIZADO ==================== */
.sparkles-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

/* Estrella dorada vectorizada ultraligera */
.sparkle {
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FFD700'%3E%3Cpath d='M12 0L14.5 9.5L24 12L14.5 14.5L12 24L9.5 14.5L0 12L9.5 9.5L12 0Z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  filter: drop-shadow(0 0 3px rgba(255, 215, 0, 0.7));
  opacity: 0.3;
}

/* Posicionamiento y tamaños ligeros */
.sparkle-1 { width: 6px;  height: 6px;  top: 14%; left: 15%; }
.sparkle-2 { width: 6px;  height: 6px;  top: 32%; right: 12%; }
.sparkle-3 { width: 6px; height: 6px; top: 58%; left: 10%; }
.sparkle-4 { width: 5px;  height: 5px;  top: 76%; right: 16%; }
.sparkle-5 { width: 5px; height: 5px; top: 24%; right: 22%; }
.sparkle-6 { width: 5px;  height: 5px;  top: 82%; left: 22%; }

/* ==================== ADORNOS ESQUINAS ==================== */
.adorno-top-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 90px;
  height: auto;
  pointer-events: none;
  z-index: 2;
}

.adorno-bottom-right {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0px !important;
  height: auto;
  pointer-events: none;
  z-index: 2;
  transform: scale(-1, -1);
}

/* Icono discreto */
.icono {
  position: relative;
  z-index: 2;
  width: 160px;
  height: auto;
  display: block;
  margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.05));
  opacity: 0.92;
}

/* Tipografías */
.titulo-script {
  position: relative;
  z-index: 2;
  font-family: 'CynthiaJuneJF', cursive;
  font-weight: 400;
  font-size: 60px;
  letter-spacing: 0.4px;
  margin: 4px 0 8px;
color: #fff;
}

.hora {
  position: relative;
  z-index: 2;
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: #fff;
  margin: 0 0 6px;
}

.lugar {
  position: relative;
  z-index: 2;
  font-family: 'padres', serif;
  font-size: 20px;
  color: #fff;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: 0.1em;
  line-height: 1.3;
}

/* ==================== FOTO CIRCULAR ==================== */
.foto-wrapper {
  position: relative;
  z-index: 2;
  width: 140px;
  height: 140px;
  margin: 12px auto 16px;
  border-radius: 50%;
  padding: 4px;
  background: linear-gradient(135deg, #a67c00 0%, #bf953f 50%, #ffffff 75%, #a67c00 100%);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}

.foto-circular {
  width: 120%;
  height: 120%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.direccion {
  position: relative;
  z-index: 2;
  font-family: 'padres', serif;
  font-style: italic;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  margin: 0 auto 18px;
  max-width: 90%;
}

/* ==================== BOTÓN DORADO ==================== */
.btn-rosa {
  display: inline-flex !important;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 14px;

  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  background-color: #bf953f;

  color: #1a1a1a !important;
  -webkit-text-fill-color: #1a1a1a !important;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1px;

  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.5);
  border: 1px solid #8a6d3b;
  cursor: pointer;
  z-index: 5;
  overflow: hidden;
}

/* Destello Mágico */
.btn-rosa .sheen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  pointer-events: none;
}

/* Aceleración por Hardware Eficiente */
.render-gpu {
  will-change: transform, opacity;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px) {
  .titulo-script { font-size: 48px; }
  .hora { font-size: 20px; }
  .lugar { font-size: 17px; }
  .foto-wrapper { width: 120px; height: 120px; }
  .adorno-top-left, .adorno-bottom-right { width: 70px; }
}

@media (prefers-reduced-motion: reduce) {
  * { transition: none !important; animation: none !important; }
}
</style>